import React from 'react'
import toastr from '@/lib/notifications'
import $ from 'jquery'
import _ from 'underscore'
import { Input } from '@/components/ui/input'
import SearchTutorsResult from './result'

class SearchTutors extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      searching: false,
      value: this.props.value || '',
      results: []
    }

    this.valueRef = React.createRef()
  }

  componentDidMount() {
    this.lazyFetchResults = _.debounce(this.fetchResults, 300)
  }

  onChange = () => {
    this.setState({
      value: this.valueRef.current.value,
      searching: true
    })

    this.props.onChange(this.valueRef.current.value)
    this.lazyFetchResults()
  }

  fetchResults() {
    const params = {
      search: this.state.value
    }

    $.ajax({
      url: "/api/sales/tutors",
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      data: params,
      success: (data) => {
        this.setState({ results: data.items })
      },
      error: (data) => {
        if (data && data.responseJSON && data.responseJSON.custom_error_message)
          toastr.error(data.responseJSON.custom_error_message)
        else
          toastr.error('something went wrong')
      }
    })
  }

  onResultClick = (result) => {
    this.setState({ searching: false, value: result.name, results: [] })
    this.props.onSelect(result)
  }

  highlightInput = (e) => {
    $(e.target).select()
  }

  render() {
    return (
      <div className="grid gap-2">
        <Input type="text" name="value" placeholder="e.g. 'Ilse Sales'" ref={this.valueRef} value={this.state.value} onChange={this.onChange} onClick={this.highlightInput} />
        {this.state.searching ?
          <ul className="grid max-h-[220px] gap-2 overflow-y-auto">
            {_.map(this.state.results, (result) => {
              return (
                <SearchTutorsResult key={result.id} result={result} onClick={this.onResultClick} />
              )
            })}
          </ul>
          : null
        }
      </div>
    )
  }
}

export default SearchTutors
